import { render, staticRenderFns } from "./GeneralList.vue?vue&type=template&id=1655ebc2&"
import script from "./GeneralList.vue?vue&type=script&lang=js&"
export * from "./GeneralList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports